import React from 'react'
import { Card, CardBody } from 'reactstrap'
import { Placeholder } from './placeholder'

export function PlaceholderCard (props) {
  return (
    <Card className='rounded-0 border-0 shadow'>
      <CardBody className='p-2 p-lg-4'>
        <Placeholder />
      </CardBody>
    </Card>
  )
}
